module.exports = __webpack_public_path__ + "img/SieWissenSichZuVerteidigen.b4b5d29a.svg";